module.exports = __webpack_public_path__ + "static/media/signal-icon4.e5c23367.svg";